'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PublishForm = require('./components/PublishForm.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PublishForm).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/publish-form/index.js
// module id = 1330
// module chunks = 0